module.exports = __webpack_public_path__ + "static/istock-623209198-compressor-d90bb95d5bda7be7497b16a740608a3a.jpg";